export function deepValue(obj, path) {
    path=path.split('.')
    for (var i=0, len=path.length; i<len; i++){
        obj = obj[path[i]]
    }
    return obj
}

export async function processQuery(store, query, path, variables={}, commit= '') {
    try {
        const result = await store.$apollo.query({
            query: query,
            fetchPolicy: 'no-cache',
            variables: variables
        })
        const data = deepValue(result, `data.admin.${path}`)
        if (commit) {
            store.commit(commit, data)
        }
        return data

    } catch(error) {
        if (error.graphQLErrors.length) {
            store.commit('setStoreErrorMessage', error.graphQLErrors[0].message)
        } else {
            store.commit('setStoreErrorMessage', error.message)
        }
    }
}

export async function processMutation(store, query, path, variables={}, commit = '') {
    try {
        const result = await store.$apollo.mutate({
            mutation: query,
            fetchPolicy: 'no-cache',
            variables: variables
        })
        const data = deepValue(result, `data.admin.${path}`)
        if (commit) {
            store.commit(commit, data)
        }
        return data
    } catch (error) {
        if (error.graphQLErrors.length) {
            store.commit('setStoreErrorMessage', error.graphQLErrors[0].message)
        } else {
            store.commit('setStoreErrorMessage', error.message)
        }
    }
}

export function genericMutations(...args) {
    return args.reduce( (acc, name) => {
        const uname = name.substr(0,1).toUpperCase() + name.substr(1)
        const f = (state, data) => {
            state[name] = data
        }
        acc[`set${uname}`] = f
        return acc
    }, {})
}
